module.exports = __webpack_public_path__ + "img/davinci.2f704263.jpg";